/* eslint-disable @typescript-eslint/no-explicit-any */
import styles from './index.css';
import { InfrastructureType } from '../../../../store/map';

let balloonLayout: Function;

export function getBalloonLayout(ymaps: YMaps.IYMaps) {
  if (!balloonLayout) {
    // tslint:disable:object-literal-shorthand no-any max-line-length no-invalid-this
    balloonLayout = ymaps.templateLayoutFactory.createClass(
      `<div class="${styles['container']}">
      <div class="${styles['items']}">
        {% for object in properties.objects %}
          <div class="${styles['item']}">
            {% if object.type == ${InfrastructureType.Schools} %}
              <svg xmlns="http://www.w3.org/2000/svg" class="${styles['icon']}" viewBox="0 0 20 20" width="20" height="20">
                <path fill="currentColor" d="M18.9 4.4h-.2l-1.7 1v9.1s-.2.2-.3.2h-.3c-1.5 0-4.2.2-6 1.2l-.4.2-.3-.1c-1.8-1-4.5-1.2-6-1.2h-.4l-.2-.2V5.5l-1.8-1H1V16c0 .1 0 .1.1.1 0 0 .1.1.1 0 .5-.1 1.4-.1 2.4-.1 2.1 0 3.8.3 4.9.9.2.1 1.1.6 1.5.6s1.4-.5 1.5-.6c1.1-.6 2.8-.9 4.9-.9 1 0 1.8.1 2.4.1h.1l.1-.1V4.6c0-.1 0-.2-.1-.2zm-7.7 10.2h.2c1.2-.5 2.8-.8 4.6-.9.1 0 .2-.1.2-.2V2.6c0-.1 0-.1-.1-.1h-.2l-4.7 2c-.1 0-.1.1-.1.2v9.7c0 .1 0 .1.1.2zm-7-1c1.8 0 3.4.3 4.6.9H9l.1-.1V4.7c0-.1 0-.1-.1-.2l-4.7-2h-.2l-.1.1v10.9c.1 0 .2.1.2.1z"/>
              </svg>
            {% elseif object.type == ${InfrastructureType.Kindergarden} %}
              <svg xmlns="http://www.w3.org/2000/svg" class="${styles['icon']}" viewBox="0 0 20 20" width="20" height="20">
                <path fill="currentColor" d="M5.6 7.9c1.4 0 2.5-1 2.5-2.3 0-.8.3-1.5-.4-1.9-.4-.2-2.1-.4-2.6-.4-.6 0-1.4.5-1.8.8-.5.4-.1.8-.1 1.5-.1 1.3 1 2.3 2.4 2.3zM3.8 5.4c.5-.1.8.1.8.1l.8-.3s-.4.5 0 .3c.8-.2 1.6-.1 2.1-.1v.3c0 .9-.8 1.7-1.8 1.7s-1.8-.8-1.8-1.7c-.1-.1-.1-.2-.1-.3zm7.5 2.7c-.1-1.2.5-2 .7-2.2.2 1.3 1.4 2.2 2.8 2.2 1.3 0 2.5-.9 2.8-2.1.2.4.6 1.2.5 2 2.4 0 1.2-2.6-.5-2.9 0-.1 0-.3-.1-.4 0-.6-.7-2.2-2.9-2.2-1.9 0-2.3 1.4-2.4 2.2-.1.2-.1.4-.1.6-2.7.4-2.4 2.8-.8 2.8zm2.2-3.4s.2.1.2.8c.4.1 1.2-1.2 1.2-1.2v1c.5.1 1.9 0 1.9 0h.1v.1c0 1.1-.9 1.9-2.1 1.9-1.1 0-2-.8-2.1-1.9.5 0 .8-.7.8-.7zm1.9 3.6h-2.2l-3 3.3-2.9-3.3H4L.6 11.8l.7.7 2.4-1.9v3.8h.5v2.9h-.3v.2h1.6v-3.2H6v3.2h1.4v-.3H7v-2.9h.6v-3.7l2 1.9.8-.2.4.1L13 10l.1.9-2.1 3.3h2.4v2.9h-.3v.4h1.4v-3.2h.5v3.2h1.4v-.3h-.3v-2.9H18L16.2 11l.1-1.2 2.2 2.7 1-1-2.9-3.2h-1.2z"/>
              </svg>
            {% elseif object.type == ${InfrastructureType.Polyclinics} %}
              <svg xmlns="http://www.w3.org/2000/svg" class="${styles['icon']}" viewBox="0 0 20 20" width="20" height="20">
                <path fill="currentColor" d="M19 7h-6V1H7v6H1v6h6v6h6v-6h6V7z"/>
              </svg>
            {% elseif object.type == ${InfrastructureType.GroceryStores} %}
              <svg xmlns="http://www.w3.org/2000/svg" class="${styles['icon']}" viewBox="0 0 20 20" width="20" height="20">
                <path fill="currentColor" d="M19.2 3.3c-.1-.2-.4-.3-.7-.3H4.9l-.2-1.2c-.1-.5-.5-.8-1-.8H1.5c-.5 0-1 .4-1 1s.4 1 1 1h1.4l1.8 11.2v.1c0 .1 0 .1.1.2 0 .1.1.1.1.2l.1.1c.1.1.1.1.2.1 0 0 .1 0 .1.1.1 0 .2.1.4.1h10.9c.5 0 1-.4 1-1s-.4-1-1-1H6.5l-.2-1h11.2c.5 0 .9-.4 1-.9l1-7c0-.3-.1-.6-.3-.9zM8.6 10H6l-.3-2h2.9v2zm0-3H5.5l-.3-2h3.4v2zm4 3h-3V8h3v2zm0-3h-3V5h3v2zm4.1 3h-3.1V8H17l-.3 2zm.4-3h-3.5V5h3.8l-.3 2zM7 16c-.8 0-1.5.7-1.5 1.5S6.2 19 7 19s1.5-.7 1.5-1.5S7.8 16 7 16zm8 0c-.8 0-1.5.7-1.5 1.5S14.2 19 15 19s1.5-.7 1.5-1.5S15.8 16 15 16z"/>
              </svg>
            {% elseif object.type == ${InfrastructureType.Cafes} %}
              <svg xmlns="http://www.w3.org/2000/svg" class="${styles['icon']}" viewBox="0 0 20 20" width="20" height="20">
                <path fill="currentColor" d="M7.49 8.5C6.292 6.2 13.78.6 5.992.5c4.493 1.9-2.396 7 1.498 8zm3.394 0c-.7-1.5 2.596-4.2.2-5 .6 1.4-2.596 4.2-.2 5zm7.688 3c-.5-.8-1.498-1.2-2.596-1.2v-.4c0-.2-.2-.3-.3-.3H1.3c-.2 0-.3.2-.3.3 0 2.1.4 4 1.198 5.7.8 1.8 1.997 3.1 3.395 3.9h5.69c.9-.5 1.698-1.2 2.397-2.2 2.596 0 4.493-1.6 4.992-3.1.5-.9.4-1.9-.1-2.7zm-1.398 2.2c-.3.8-1.198 1.6-2.496 1.9.5-1.1.9-2.4 1.098-3.7h.1c.6 0 1 .2 1.198.5.3.4.3.8.1 1.3z"/>
              </svg>
            {% endif %}
            {% if properties.objects.length == 1 %}<h4 class="${styles['header']}">{{object.name}}</h4>{% endif %}
            {% if properties.objects.length > 1 %}<a class="${styles['header']} ${styles['header--link']}">{{object.name}}</a>{% endif %}
            <p class="${styles['type']}">{{object.category}}</p>
            {% if properties.objects.length == 1 && (object.phones || object.url) %}
              <div class="${styles['contacts']}">
                {% if object.phones %}<div class="${styles['phones']}">{{object.phones}}</div>{% endif %}
                {% if object.url %}<a class="${styles['url']}" href="{{object.url}}" target="_blank" rel="nofollow noopener">{{object.url}}</a>{% endif %}
              </div>
            {% endif %}
          </div>
        {% endfor %}
      </div>
      <button class="${styles['close']}">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.728 12.728" width="13" height="13">
          <path fill="currentColor" d="M6.364 4.95L1.414 0 0 1.414l4.95 4.95L0 11.314l1.414 1.414 4.95-4.95 4.95 4.95 1.414-1.414-4.95-4.95 4.95-4.95L11.314 0l-4.95 4.95z"/>
        </svg>
      </button>
    </div>`,
      {
        build() {
          (this.constructor as any).superclass.build.call(this);

          (this as any)._balloon = document.querySelector(`.${styles['container']}`) as Element;
          if ((this as any)._balloon) {
            (this as any)._balloon.style.bottom = `${(this as any)._balloon.offsetHeight + 62}px`;
          }

          const closeButton = document.querySelector(`.${styles['close']}`) as Element;
          closeButton.addEventListener('click', event => (this as any).onCloseClick(event));

          const links = document.querySelectorAll(`.${styles['header--link']}`);
          if (links.length > 0) {
            [].forEach.call(links, (node: Element, index: number) => {
              node.addEventListener('click', () => (this as any).onLinkClick(index));
            });
          }
        },
        getShape() {
          const balloon = (this as any)._balloon;

          if (!balloon) {
            return (this.constructor as any).superclass.getShape.call(this);
          }
          const { offsetLeft, offsetTop, offsetWidth, offsetHeight } = balloon;
          const { shape, geometry } = ymaps as any;

          return new shape.Rectangle(
            new geometry.pixel.Rectangle([
              [offsetLeft, offsetTop],
              [offsetLeft + offsetWidth, offsetTop + offsetHeight],
            ]),
          );
        },
        onCloseClick(event: any) {
          event.preventDefault();

          (this as any).events.fire('userclose');
        },
        onLinkClick(index: number) {
          const data = (this as any).getData();
          data.properties.set('objects', [data.properties.get('objects')[index]]);
        },
      },
    );
  }

  return balloonLayout;
}
